import * as React from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";

export default function RadioButtonsGroup({ setFormat }) {
  return (
    <FormControl sx={{ mt: 2 }}>
      <FormLabel
        id="radio-buttons-group-label"
        sx={{
          "&.Mui-focused": {
            color: "#008c23",
          },
        }}
      >
        Available Formats
      </FormLabel>
      <RadioGroup
        aria-labelledby="radio-buttons-group-label"
        defaultValue="XLS"
        name="radio-buttons-group"
        onChange={(e) => setFormat(e.target.value)}
      >
        <FormControlLabel
          value="XLS"
          control={
            <Radio
              sx={{
                color: "#008c23",
                "&.Mui-checked": { color: "#008c23" },
              }}
            />
          }
          label={<span style={{ fontWeight: 900 }}>XLSX</span>}
        />
        <FormControlLabel
          value="CSV"
          control={
            <Radio
              sx={{
                color: "#008c23",
                "&.Mui-checked": { color: "#008c23" },
              }}
            />
          }
          label={<span style={{ fontWeight: 900 }}>CSV</span>}
        />
      </RadioGroup>
    </FormControl>
  );
}
